import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ATTEMPT_STATUS as AttemptStatus } from 'types/enums';
import { translate } from 'translations/translator';

interface Props {
  status: AttemptStatus;
}

const ATTEMPT_STATUS_CLASS_MAPPING = {
  [AttemptStatus.NOT_STARTED]: 'notStarted',
  [AttemptStatus.IN_PROGRESS]: 'inProgress',
  [AttemptStatus.COMPLETED]: 'completed'
};

const getStatusT = (status: string) => {
  return translate('assignmentTracker', status);
};

const AttemptStatusChip: React.FC<Props> = ({ status }) => {
  const theme = useTheme();
  const classes = useStyles(theme)();
  return (
    <Chip
      size="small"
      label={getStatusT(status)}
      color="primary"
      classes={{
        label: classes.label,
        colorPrimary: classes[ATTEMPT_STATUS_CLASS_MAPPING[status]]
      }}
    />
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    label: () => ({
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightMedium
    }),
    notStarted: { backgroundColor: theme.palette.grey['500'] },
    inProgress: { backgroundColor: theme.palette.warning.light },
    completed: { backgroundColor: theme.palette.success.main }
  }));

export default AttemptStatusChip;
